import { mapGetters } from 'vuex'

export default {
  methods: {
    setHref(value) {
      if (this.isString(value) && !value.match(/:\/\//g)) {
        // remove region from the url and cleans up rare cases where the
        // internal links may double-slash.
        value = `/${value.replace(this.region, '').replace(/^\/+/g, '')}`
      }
      return value
    },
    isString(value) {
      return value.length > 0 && typeof value === 'string'
    },
  },
  computed: {
    ...mapGetters({
      region: 'globals/getRegion',
    }),
    href() {
      return this.setHref(
        (this.cms.href || {}).url ||
          (this.cms.href || {}).cached_url ||
          this.url ||
          ''
      )
    },
    blank() {
      if (this.isString(this.href)) {
        return this.href.match(/:\/\//g) ? '_blank' : ''
      }
    },
  },
}
